module.exports = __webpack_public_path__ + "img/place.24cf39da.png";